import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { TabsWrapper } from "./tabs.styles.es.js";
import { tabsContext } from "./tabs-context.es.js";
import "react";
import "@reach/auto-id";
import "lodash/fp";
import "styled-components";
import { useControlledState } from "../../hooks/use-controlled-state.es.js";
import "../../contexts/display-mode-context/display-mode-context.es.js";
import "../../contexts/global-edit-context/global-edit-context.es.js";
import "../../contexts/toast-context/toast-context.es.js";
import "../../utils/is-valid-ref.es.js";
import "../../hooks/use-horizontal-scroll.es.js";
import "react-use-measure";
import "@juggle/resize-observer";
import "@reach/utils";
import "@reach/rect";
import "compute-scroll-into-view";
const { Provider } = tabsContext;
const propTypes = {
  activeKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func
};
const defaultProps = {
  activeKey: void 0,
  onChange: void 0
};
const Tabs = ({ activeKey, onChange, ...restProps }) => {
  const tabState = useControlledState(activeKey, onChange);
  return /* @__PURE__ */ jsx(Provider, { value: tabState, children: /* @__PURE__ */ jsx(TabsWrapper, { ...restProps }) });
};
Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;
export {
  Tabs
};
